'use strict'

import React,{Component} from 'react';

import AreaForm from '../components/AreaForm.jsx';
import Diff from '../components/Diff.jsx';

import IssueMenu from './IssueMenu.jsx';
import IssueReportPreview from './IssueReportPreview.jsx';

import Translations from '../../app/utils/translations.js';

let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
]);

import formDefinition from './formDefinition.js';

class ExamineSummary extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.examineDetails;
    return (
      <div>
        <div style={{fontSize:"12pt"}}>
          <b>{this.props.no!==undefined ? this.props.no+". " : null}<Diff newValue={this.props.title} value={this.props._original.title}/></b>
        </div>
        <div>
          (<Diff newValue={labels.typeValues[this.props.type]} value={labels.typeValues[this.props._original.type]}/>)
        </div>
        <div style={{paddingTop: 5}}>
          <div>
            <b>{labels.description}:</b>
          </div>
          <div>
            <i><Diff newValue={this.props.description} value={this.props._original.description}/></i>
          </div>
        </div>
      </div>
    );
  }
}


class ProposeSummary extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.proposeDetails;
    return (
      <div>
        <ExamineSummary {...this.props}/>
        <div style={{paddingTop: 5}}>
          <div>
            <b>{labels.impact}:</b>
          </div>
          <div>
             <i><Diff newValue={this.props.impact} value={this.props._original.impact}/></i>
          </div>
        </div>
      </div>
    );
  }
}

class DecideSummary extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.decideDetails;
    return (
      <div>
        <ProposeSummary {...this.props}/>
        {this.props.options!==undefined || this.props._original.options!==undefined ?
        (
          <div style={{paddingTop: 5}}>
            <div>
              <b>{labels.options}:</b>
            </div>
            <div>
               <i><Diff newValue={this.props.options} value={this.props._original.options}/></i>
            </div>
          </div>
        ) : null}
        <div style={{paddingTop: 5}}>
          <div>
            <b>{labels.recommendation}:</b>
          </div>
          <div>
            <i><Diff newValue={this.props.recommendation} value={this.props._original.recommendation}/></i>
          </div>
        </div>
      </div>
    );
  }
}

class ImplementSummary extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.implementDetails;
    return (
      <div>
        <ExamineSummary {...this.props}/>
        <div style={{paddingTop: 5}}>
          <div>
            <b>{labels.decision}:</b>
          </div>
          <div>
            <i><Diff newValue={this.props.decision} value={this.props._original.decision}/></i>
          </div>
        </div>
      </div>
    );
  }
}

export default class IssueForm extends React.Component {
  constructor(props) {
    super(props);
    this.state={showPreview:false, item:props.item};
  }

  tabSummary(tab, details) {
    var content=undefined;
    let values=details.values;
    let originalValues=details.oldValues;
    switch (tab) {
      case "Examine":
        content=<ExamineSummary {...values} _original={originalValues} language={this.props.language}/>
        break;
      case "Propose":
        content=<ProposeSummary {...values} _original={originalValues} language={this.props.language}/>
        break;
      case "Decide":
        content=<DecideSummary {...values} _original={originalValues} language={this.props.language}/>
        break;
      case "Implement":
        content=<ImplementSummary {...values} _original={originalValues} language={this.props.language}/>
        break;
      default:
        content=undefined;
    }
    return content!==undefined ? (
      <div style={{fontFamily:"Arial", fontSize:"10pt", padding:10}}>
        {content}
      </div>
    ) : null;
  }

  componentWillReceiveProps(props) {
    this.setState({modified:undefined, item:props.item});
  }

  showReportPreview(event) {
    event.preventDefault();
    this.setState({showPreview: !this.state.showPreview, reportType:undefined});
  }

  showExceptionReportPreview(event) {
    event.preventDefault();
    this.setState({showPreview: !this.state.showPreview, reportType:"exception"});
  }

  createIssueReport(event) {
    event.preventDefault();
    if (this.props.createReport!==undefined) {
      this.props.createReport(this.props.item, this.state.reportType==="exception");
    } else {
      window.alert("Publish is not supported");
      this.setState({showPreview: !this.state.showPreview});
    }
  }

  handleFieldChange(fieldName) {
    return (event)=>{
      this.setState({
        item:Object.assign({},this.state.item,{[event.target.name]:event.target.value}),
        modified:true
      });
    };
  }

  render() {
    let labels=translations.getTranslation(this.props.language,this.props.variant);
    var areas=translations.createTranslatedForm(formDefinition,this.props.language,this.props.variant);
    return (
      <div>
        {this.state.showPreview ? (
          <IssueReportPreview
            {...this.props}
            cancel={this.showReportPreview.bind(this)}
            publish={this.createIssueReport.bind(this)}
            issue={this.props.item}
            exception={this.state.reportType==="exception"}
          />
        ) : (
          <div>
            {this.props.item!==undefined && this.props.hideMenu!==true ? (
              <IssueMenu
                {...this.props}
                {...this.props.item}
                createReport={this.showReportPreview.bind(this)}
                createExceptionReport={this.showExceptionReportPreview.bind(this)}
              />
            ) : null}
            <div style={{display:"flex", justifyContent:"center"}}>
              <div style={{backgroundColor:"white", padding:20, borderRadius:10, width:1016}}>
                <AreaForm
                  {...this.props}
                  areas={areas}
                  display="tab"
                  label={labels.issue}
                  summary={this.tabSummary.bind(this)}
                  updatedItem={this.state.item}
                  modified={this.state.modified}
                  handleFieldChange={this.handleFieldChange.bind(this)}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/change/IssueForm.jsx